module.exports = __webpack_public_path__ + "static/img/noauth.bf77a2dc.png";